import Marquee from "react-fast-marquee";
import { Quotes } from "@phosphor-icons/react";
import { Reveal, Eyebrow } from "./Motion";
import { TESTIMONIALS } from "../constants/site";

export default function Testimonials() {
  return (
    <section className="relative border-y hairline bg-[color:var(--surface)] py-24 sm:py-28 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 mb-14">
        <Reveal>
          <Eyebrow>Kind words</Eyebrow>
          <h2 className="font-display font-light text-5xl sm:text-6xl mt-4 text-[color:var(--text)]">
            Loved by <span className="italic text-gradient-gold">clients</span>
          </h2>
        </Reveal>
      </div>

      <Marquee speed={45} gradient={false} pauseOnHover autoFill>
        {TESTIMONIALS.map((t, i) => (
          <div
            key={i}
            data-testid={`testimonial-${i}`}
            className="mx-4 w-[340px] sm:w-[440px] shrink-0 rounded-lg border border-[color:var(--gold)]/20 bg-[color:var(--bg)] p-8 hover:border-[color:var(--gold)]/50 transition-colors duration-500"
          >
            <Quotes size={30} weight="fill" className="text-[color:var(--gold)] opacity-70" />
            <p className="font-display text-xl sm:text-2xl leading-snug text-[color:var(--text)] mt-4">
              “{t.quote}”
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="h-px w-8 bg-[color:var(--gold)]" />
              <div>
                <p className="text-[color:var(--text)] text-sm font-medium">{t.name}</p>
                <p className="font-mono-x text-[10px] tracking-[0.25em] uppercase text-[color:var(--muted)]">{t.role}</p>
              </div>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
